import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import { rosterAPI } from '@/providers/apis/roster/roster';

@Component({
    name: 'rosters-upload-list-page',
    components: {
        'popup-slide': () => import('@/components/cards/slide-popup-layout/slide-popup-layout.vue'),
    },
})

export default class RostersUploadListPage extends Vue {

    // ------------------------------------------------------------------------
    // Properties

    private fieldsItems: any = [
        {
            label: 'S.No',
            key: 'index',
        },
        {
            label: 'File Name',
            key: 'fileName',
        },
        {
            label: 'Uploaded Date',
            key: 'updatedAt',
        },
        {
            label: 'Total Sync',
            key: 'totalSyncs',
        },
        {
            label: 'Sync Status',
            key: 'status',
        },
    ];

    private currentPage: number = 1;

    private offset: number = 0;

    private limit: number = 10;

    private uploadList: any = [];

    private filterBy: any = null;

    private dataBind: any = {};

    private isShowPullup: boolean = false;

    private isLoading: boolean = false;

    private totalRowCounts: number = 1;

    // ------------------------------------------------------------------
    // Actions

    public onGoBack() {
        this.$router.push('/users-rosters/roster-syncs');
    }

    private showMoreDetails(row: any) {
        this.dataBind.activeRoster = row;
        this.isShowPullup = true;
    }

    private onCloseSlide() {
        this.isShowPullup = false;
    }

    // ----------------------------------------------------------------
    // Hooks

    private created() {
        this.fetchUploadedList();
    }

    private fetchUploadedList() {
        this.isLoading = true;
        const params = {
            limit: this.limit,
            offset: this.offset,
        };
        axios.all([
            rosterAPI.fetchRosterUploads(params),
        ]).then(axios.spread((data) => {
            this.totalRowCounts = data.totalCount;
            this.uploadList = data.uploadList;
            this.isLoading = false;
        }));
    }

    private refreshList() {
        this.offset = 0;
        this.uploadList = [];
        this.fetchUploadedList();
    }

    private onSelectPage(pageNumber: number) {
        this.uploadList = [];
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.fetchUploadedList();
    }
}
